<template>
<div class="content-box">
    <div ref="searchBoxRef" class="content-header">
        <el-button @click="handleCreate" type="button">+ 添加产品</el-button>
    </div>
    <div class="table-list">
        <ETable v-loading="loading" :max-height="tableMaxheight" :columns="columns" :data="tableData" style="width: 100%" :header-cell-style="headerCellStyle" :cell-style="cellStyle" border>
            <template #name="{row}">
                <div style="display: flex;align-items: center;">
                    <el-image :preview-src-list="[row.img]" style="flex-shrink: 0;width: 80px;height: 80px;margin-right: 5px" fit="contain" :src="row.img"></el-image>
                    {{row.name}}
                </div>
            </template>
            <template #status="{row}">
                <span :class="{ 'enable-btn': !row.status }">
                    {{ row.status ? "已启用" : "已禁用" }}
                </span>
            </template>
            <template #action="{row}">
                <el-button type="text" @click="delRecord(row)">移除</el-button>
            </template>
        </ETable>
    </div>

    <SettingTableTransfer @syncList="searchData" :stashList="stashList" :visible.sync="showTransfer"></SettingTableTransfer>
</div>
</template>

    
    
<script>
import {
    Mixins,
    Component,
    Ref, InjectReactive, Watch
} from "vue-property-decorator";
import tablePagination from "@/mixins/tablePagination";
import ETable from "@/components/ETable.vue";
import Resize from "@/mixins/resize";

import UploadImg from "@/components/uploadImg.vue";

import SettingTableTransfer from "./settingTableTransfer.vue";

import { wsSymptomProductList, wsSymptomOneProductDel } from "@/api/wsProduct";

@Component({ name: 'wsProduct-components-settingTable',
    components: {
        ETable,
        UploadImg,
        SettingTableTransfer
    }
})
export default class WsProductSetting extends Mixins(tablePagination, Resize) {
    @Ref("validateForm") ValidateFormRef;

    showTransfer = false;

    // tempSurplusHeight = 180;
    // stashList = [];

    @InjectReactive() storeId;
    @InjectReactive() symptomId;

    get stashList() {
        return this.tableData?.map((el) => {
            return el
        })
    }

    queryForm = {}
    columns = [{
            label: "产品 ID",
            prop: "id"
        },
        {
            label: "产品信息",
            prop: "name",
            minWidth: "180px"
        },
        {
            label: "产品功效",
            prop: "effect",
            minWidth: "180px"
        },
        {
            label: "状态",
            prop: "status",
            width: "100px"
        },
        {
            label: "添加人",
            prop: "createdBy",
            minWidth: "100px"
        },
        {
            label: "添加时间",
            prop: "createdTime",
            minWidth: "140px"
        },
        {
            label: "操作",
            prop: "action",
            minWidth: "100px"
        },
    ]

    tableData = []; 

    loading = false;

    mounted() {
        this.windowResize(120);
    }

    searchData() {
        console.log("searchData")
        this.getProductList(this.symptomId);
    }

    handleCreate() {
        this.showTransfer = true;
    }

    dialogClose() {
        this.ValidateFormRef?.resetFields();
        this.dialogVisible = false;
    }

    delRecord(row) {
        const params = {
            id: row.id,
            presSymptomId: this.symptomId
        }
        wsSymptomOneProductDel(params).then((res) => {
            this.getProductList(this.symptomId);
        })
    }

    // getData() {
    //     wsSymptomOneProductList({ id: this.symptomId, storeId: this.storeId }).then((res) => {
    //         console.log("res------", res)
    //     })
    // } 

    @Watch("symptomId")
    getProductList(symptomId) {
        console.log("symptomId---", symptomId)
        if (!symptomId) return;
        this.loading = true;
        console.log("symptomId---")
        wsSymptomProductList({ storeId: this.storeId, id: this.symptomId }).then((res) => {
            console.log("res", res)
            this.tableData = res.data || [];
        }).finally(() => {
            this.loading = false;
        })
    }
}
</script>
    
    
<style lang="scss" scoped>
@import "@/styles/app";

.content-box {
    background: #edf0f9;
}

.content-header {
    background: #ffffff;
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    // padding: 20px;
}

.table-list {
    margin-top: 20px;
    background: #ffffff;
    border-radius: 8px;
}

.input {
    width: 240px;
    margin-right: 12px;
    margin-bottom: 10px;
}

.button-on {
    font-size: 14px;
    font-weight: 400;
}

.status-off {
    font-size: 14px;
    font-weight: 400;
    color: #ff6700;
}
</style>
